import { render, staticRenderFns } from "./PsychometryReport.vue?vue&type=template&id=7f7f6b12&scoped=true&"
import script from "./PsychometryReport.vue?vue&type=script&lang=js&"
export * from "./PsychometryReport.vue?vue&type=script&lang=js&"
import style0 from "./PsychometryReport.vue?vue&type=style&index=0&id=7f7f6b12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7f6b12",
  null
  
)

export default component.exports